/**
 * Web stub for Mixpanel: delegates to queue-aware helpers.
 * Prevents mixpanel-react-native from being bundled on web.
 */

import { mixpanelTrack, mixpanelIdentify, mixpanelReset } from './mixpanel.client'

const noopAsync = (): Promise<void> => Promise.resolve()

export const Mixpanel = {
  init: (_options?: { token?: string; trackAutomaticEvents?: boolean }) => noopAsync(),
  track: (event: string, props?: Record<string, unknown>) => {
    mixpanelTrack(event, props)
  },
  identify: (distinctId: string) => {
    mixpanelIdentify(distinctId)
  },
  reset: () => {
    mixpanelReset()
  },
  getPeople: () => ({
    set: (_props: Record<string, unknown>) => {
      // No-op on web: people.set is handled inside mixpanelIdentify
    },
  }),
}
